import { PropertyType as PropertyTypeEnum, RoomIcon } from '@/entities/room'
import { cn } from '@/shared/lib'

import { PROPERTY_TYPES } from './option'
import { ExpandButton, useExpand } from '../../../lib/expand'
import { FilterType } from '../../../model/filter'
import { Title, List, Item } from '../../common/layout'

type Props = {
  type: FilterType
  defaultExpanded: boolean
  ref: (element: HTMLDivElement) => void
  className?: string
  selected: (value: PropertyTypeEnum) => boolean
  onExpand: () => void
  onChange: (value: PropertyTypeEnum) => void
}

const LIMIT = 4

export const PropertyTypesInDialogView = ({
  type,
  defaultExpanded,
  ref,
  className,
  selected,
  onExpand,
  onChange,
}: Props) => {
  const { expanded, toggleExpand } = useExpand({
    defaultExpanded,
  })

  const propertyTypeList = expanded
    ? PROPERTY_TYPES
    : PROPERTY_TYPES.slice(0, LIMIT)

  const handleExpandButtonClick = () => {
    toggleExpand()
    onExpand()
  }

  const handlePropertyTypeChange = (value: PropertyTypeEnum) => () => {
    onChange(value)
  }

  return (
    <div className={className} ref={ref}>
      <Title>건물 유형</Title>
      <List>
        {propertyTypeList.map(({ title, value, icon }) => (
          <Item
            key={title}
            type={type}
            size="large"
            initialWidth={80}
            selected={selected(value)}
            onClick={handlePropertyTypeChange(value)}
            className="whitespace-nowrap"
          >
            {type === FilterType.Dialog && (
              <RoomIcon name={icon} width={50} height={38} className="mb-1" />
            )}
            <p
              className={cn(
                'flex h-11 items-center justify-center',
                type === FilterType.Dialog && 'whitespace-break-spaces',
              )}
            >
              {title}
            </p>
          </Item>
        ))}
      </List>

      {type === FilterType.Dialog && (
        <div className="mt-4 flex justify-center">
          <ExpandButton expanded={expanded} onClick={handleExpandButtonClick} />
        </div>
      )}
    </div>
  )
}
